// src/pages/Forbidden.jsx
import React from 'react';
export default function Forbidden() {
    return (
        <div style={{ padding: 24 }}>
            <h2>Access denied</h2>
            <p>You don�t have permission to view this page.</p>
            <a href="/">Go home</a>
        </div>
    );
}
